$(document).ready(function () {
  const maxDuration = 10000; // 10 seconds
  const startTime = Date.now();

  const interval = setInterval(() => {
    const widgetEl = document.querySelector('recharge-subscription-widget');
    if (!widgetEl) return;

    const shadow = widgetEl.shadowRoot;
    if (!shadow) return;

/*    const style = document.createElement('style');
    style.setAttribute('data-injected', 'true');
    style.textContent = `
      button.recharge-button ._15b7gxl0 ._15b7gxl0 ._15b7gxl0 {
        padding: 3px !important;
      }`;
    shadow.appendChild(style);
*/    

    const rootElement = shadow.querySelector('.rc-widget__root');
    if (rootElement) {
      // Inject base styles once
      if (!shadow.querySelector('style[data-injected]')) {
        const style = document.createElement('style');
        style.setAttribute('data-injected', 'true');
        style.textContent = `
          .rc-benefits__list li {
            margin: 0 !important;
          }

          .rc-plans-dropdown__select,
          .rc-plans__label {
            font-size: 16px !important;
          }

          .rc-purchase-option__label {
            padding: 12px 20px !important;
            flex-direction: row !important;
            justify-content: space-between !important;
          }

          .rc-purchase-option__selector {
            /*font-size: 16px !important;*/
            padding: 0 !important;
          }
          .rc-purchase-option__badge {
            position: unset !important;
            margin-right: auto !important;
            margin-left: 20px !important;
          }

                .rc-purchase-option__subscription {
                  overflow: hidden !important;
                  max-height: 48px !important;
                  transition: max-height 0.5s 0.1s !important;
                }
              .rc-purchase-option[rc-selected] {
                  max-height: 300px !important;
                }
          
    
        `;
        shadow.appendChild(style);
        console.log("✅ Base styles injected into recharge-subscription-widget");
      }

      // ✅ Also insert badge on load
      (function insertBadgeOnLoad() {
        const badge = shadow.querySelector('.rc-purchase-option__badge');
        const selectors = shadow.querySelectorAll('.rc-purchase-option__selector');
        
        if (!badge) {
          console.warn("❌ .rc-purchase-option__badge not found (on load)");
        } else if (selectors.length < 2) {
          console.warn("❌ Not enough .rc-purchase-option__selector elements found (on load)");
        } else {
          selectors.forEach(selector => {
            if (!selector.classList.contains('rc-purchase-option__selector_subscription')) {
              const parent = selector.parentElement;
              if (!parent) return;

              if (badge.parentElement !== parent || badge.previousElementSibling !== selector) {
                parent.insertBefore(badge, selector.nextSibling);
                console.log('✅ .rc-purchase-option__badge inserted on load after non-subscription selector');
              }
            }
          });
        }
      })();

      // Add click handler (once) for the subscription label
      const label = shadow.querySelector('.rc-purchase-option__subscription');
      if (label && !label.hasAttribute('data-click-bound')) {
        label.setAttribute('data-click-bound', 'true');

        label.addEventListener('click', () => {
          console.log('🖱️ .rc-purchase-option__subscription clicked');

          setTimeout(() => {
            // === Handle rc-benefits ===
            const rcBenefits = shadow.querySelector('rc-benefits');
            if (rcBenefits?.shadowRoot && !rcBenefits.shadowRoot.querySelector('style[data-benefits-style]')) {
              const style = document.createElement('style');
              style.setAttribute('data-benefits-style', 'true');
              style.textContent = `
                .rc-benefits__list li,
                .rc-benefits__list li p {
                  margin: 0 !important;
                  font-size: 15px !important;
                }


                
              `;
              rcBenefits.shadowRoot.appendChild(style);
              console.log('✅ CSS injected into rc-benefits shadow DOM');
            }

            // === Handle rc-selling-plans ===
            const rcPlans = shadow.querySelector('rc-selling-plans');
            if (rcPlans?.shadowRoot && !rcPlans.shadowRoot.querySelector('style[data-selling-style]')) {
              const style = document.createElement('style');
              style.setAttribute('data-selling-style', 'true');
              style.textContent = `
                .rc-plans-dropdown,
                .rc-plans-dropdown__select {
                  font-size: 15px !important;
                }
                .rc-purchase-option__badge {
                    position: unset !important;
                    margin-right: auto !important;
                    margin-left: 20px !important;
                }
              `;
              rcPlans.shadowRoot.appendChild(style);
              console.log('✅ CSS injected into rc-selling-plans shadow DOM');
            }

            // ✅ Also insert badge again after click (in case DOM changed)
            const badge = shadow.querySelector('.rc-purchase-option__badge');
            const selectors = shadow.querySelectorAll('.rc-purchase-option__selector');
            
            if (!badge) {
              console.warn("❌ .rc-purchase-option__badge not found (on click)");
            } else if (selectors.length < 2) {
              console.warn("❌ Not enough .rc-purchase-option__selector elements found (on click)");
            } else {
              selectors.forEach(selector => {
                if (!selector.classList.contains('rc-purchase-option__selector_subscription')) {
                  const parent = selector.parentElement;
                  if (!parent) return;

                  if (badge.parentElement !== parent || badge.previousElementSibling !== selector) {
                    parent.insertBefore(badge, selector.nextSibling);
                    console.log('✅ .rc-purchase-option__badge inserted after non-subscription selector (on click)');
                  }
                }
              });
            }

          }, 150); // wait for dynamic render
        });
      }

      clearInterval(interval); // once everything is set up
    }

    if (Date.now() - startTime > maxDuration) {
      clearInterval(interval);
      console.warn('⏰ Timeout: Recharge widget not ready in time');
    }
  }, 100);
});


$(document).ready(function() {
  $('#ruffruff-table-of-contents').appendTo('#table-contents');
});

document.addEventListener("touchstart", function() {},false);

var cart_config = document.getElementById('cart-config');
var cart_config_ = JSON.parse(cart_config.innerHTML || '{}');
Shopify.money_format = cart_config_.money_format

var $window = $(window);

$window.on('resize', function(){
}).trigger('resize');


$(document).ready(function() {
  // Move subscription widget above add to cart button
  $('.recharge-subscription-widget').appendTo('.recharge-widget');
  
  $('.trigger-addtocart').on('click', function() {
    $(this).addClass('loading');
    $('.product-add .product__add-button').click();
  });

  $('.trigger-klaviyo-notify').on('click', function() {
    $(this).addClass('loading');
    $('.klaviyo-notify-btn.klaviyo-bis-trigger')[0].click();
  });

  setTimeout(function() {
    window.dispatchEvent(new Event('resize'));
  }, 1000)

  $('.atc-btn-sticky').click(function() {
    console.log('clicked')
    $(this).text('Adding...')
    $('.product-add #addToCart').click()
  });

  $('.product-info-tooltip .close').click(function() {
    $(this).closest('.product-info-tooltip').removeClass('active');
  });

  $('body').on('click', '.tooltip', function() {
    $(this).next('.product-info-tooltip').addClass('active')
  });
  
  $('body').on('click','.tooltip-hover .product-info-tooltip.active', function(e) {
    if (e.target !== this)
      return;
    $('.product-info-tooltip.active').removeClass('active');
  });

  $('.product-tabs .tab').click(function() {
    $(this).closest('.product-detail-tabs').find('.active').removeClass('active');
    var tab = $(this).attr('tab')
    $(this).addClass('active');
    $(this).closest('.product-detail-tabs').find('.tab-content[content="' + tab + '"]').addClass('active')
  })

  $('.cart-links__link-search').click(function(e) {
    e.preventDefault();
    $('.header-search-overlay').fadeIn();
    $('.announcement-bar__search-input').focus();
  });

  $('.search-bar__close').click(function(e) {
    e.preventDefault();
    $('.header-search-overlay').fadeOut();
  });

  $('.collection-tab-list .tab').click(function() {
    var container = $(this).closest('.collection-tabs-section');
    container.find('.tab').removeClass('active');
    $(this).addClass('active')
    var tab = $(this).attr('tab-name');

    container.find('.collection-product-grid .product-grid').removeClass('show');
    container.find('.collection-product-grid .product-grid[tab-name="' + tab + '"]').addClass('show');

    if(tab == 'DOG PRODUCTS') {
      $(this).closest('.collection-tabs-section').find('.tab-name-selector').text('Dog Supplements');
    }
    else {
      $(this).closest('.collection-tabs-section').find('.tab-name-selector').text('Cat Supplements');
    }
  });

  $('.btn-form-submit').on('click', function() {
    $('#customer_login').removeAttr('data-login-with-shop-sign-in')
    $('#customer-login [name="checkout_url"]').remove();
    $('.btn-form-submit-hidden').click();
  });

});

$(document).ready(function() {
  
  if($(window).width() > 768) {
    $('body').on('mouseenter', '.tooltip-hover .tooltip',function() {
      var tooltipContainer = $(this).parent().find('.product-info-tooltip');
      tooltipContainer.addClass('active');
    });
    $('body').on('mouseleave', '.tooltip-hover',function() {
      $(this).find('.product-info-tooltip').removeClass('active')
    });
  }

  $('[name="selling_plan-1"]').on('change', function() {
    if($('[name="selling_plan-1"][value="subscription"]:checked').length > 0) {
      $('.afterpay-wrapper').addClass('active');
    }
    else {
      $('.afterpay-wrapper').removeClass('active');
    }
  });

  $('.most-popular-variant label').click();

  $('body').on('change', '.product-grid-addtocart select', function() {
    var optionPrice = $(this).find('option:selected', this).attr('variant-price');
    $(this).closest('.product-index').find('.product-info .price').html(optionPrice)
  })
  
});


// Tabs Javascript Script 

class TabContainer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const tabButtons = this.querySelectorAll(".tab-button");

    tabButtons.forEach((tabButton) => {
      const handleTabInteraction = (event) => {
        event.stopPropagation();
        const currentTabContentId = tabButton.getAttribute("data-tab-content");
        const currentTitleContentId = tabButton.getAttribute("data-tab-title");
        const currentTabContent = this.querySelector(currentTabContentId);
        const currentTabTitle = this.querySelector(currentTitleContentId);

        tabButtons.forEach((button) => {
          button.classList.remove("is-active");
        });

        tabButton.classList.add("is-active");

        this.querySelectorAll(".tab-content").forEach((tabContent) => {
          tabContent.classList.remove("is-active");
        });

        currentTabContent.classList.add("is-active");


        this.querySelectorAll(".section--title").forEach((titleContent) => {
          titleContent.classList.remove("is-active");
        });

        currentTabTitle.classList.add("is-active");
        
      };

      tabButton.addEventListener("click", handleTabInteraction);
      tabButton.addEventListener("touchstart", handleTabInteraction);
    });

  }
}

customElements.define("tab-container", TabContainer);


// Custom Product Form

class CustomProductForm extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.card = this.querySelector(".item-wrapper");
    this.variantButtons = this.querySelectorAll(".variant-button");
    this.atcButton = this.querySelector("button[type='submit']");

    if (!this.variantButtons.length || !this.atcButton) return;

    this.selectedVariantId = this.card.getAttribute("data-selected-variant");

    this.bindVariantButtons();
    this.bindAddToCart();
  }

  bindVariantButtons() {
    this.variantButtons.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();

        this.variantButtons.forEach((b) => b.classList.remove("selected"));
        btn.classList.add("selected");

        const variantId = btn.dataset.variant;
        if (variantId) {
          this.selectedVariantId = variantId;

          if (this.card) {
            this.card.setAttribute("data-selected-variant", variantId);
          }
        } else {
          console.warn("⚠️ No data-variant found on clicked button");
        }
      });
    });
  }

  bindAddToCart() {
    this.atcButton.addEventListener("click", (e) => {
      e.preventDefault();

      // if (!this.selectedVariantId) {
      //   console.warn("⚠️ No variant selected yet!");
      //   return;
      // }

      const body = JSON.stringify({
        id: this.selectedVariantId,
        quantity: 1,
      });

      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body,
      })
        .then((res) => res.json())
        .then((data) => {
          // console.log("🛒 Added to cart:", data);
          window.location.href = "/cart";
        })
        .catch((err) => console.error("Add to cart error:", err));
    });
  }
}

customElements.define("custom-product-form", CustomProductForm);

// =============================================================================
// PETZPARK — Customer Fields customisation
// =============================================================================


// =============================================================================
// Smooth-scroll to Add Pet button
// =============================================================================
(function () {
  var ORIGIN_KEY     = 'petzpark_profile_explainer_add_pet_origin';
  var ORIGIN_TS_KEY  = ORIGIN_KEY + '_ts';
  var ORIGIN_TTL_MS  = 10 * 60 * 1000;
  var DID_SCROLL_KEY = ORIGIN_KEY + '_did_scroll';

  var DEBUG = true;
  function log() {
    if (!DEBUG) return;
    console.log.apply(console, ['[PZP][CF]'].concat(Array.prototype.slice.call(arguments)));
  }

  document.addEventListener('click', function (e) {
    try {
      var a = e.target && e.target.closest ? e.target.closest('a') : null;
      if (!a) return;
      var href = a.getAttribute('href') || '';
      var text = (a.textContent || '').replace(/\s+/g, ' ').trim();
      var url;
      try { url = new URL(href, window.location.origin); } catch (_) { return; }
      var isPetProfileFormPath = url.pathname === '/pages/pet-profile-form';
      var looksLikeAddPetCta =
        /add a pet/i.test(text) ||
        !!a.closest('.pet-profiles_buttons') ||
        a.classList.contains('button');
      if (!isPetProfileFormPath || !looksLikeAddPetCta) return;
      log('click -> set origin flag', { href: href, text: text });
      sessionStorage.setItem(ORIGIN_KEY,    '1');
      sessionStorage.setItem(ORIGIN_TS_KEY, String(Date.now()));
      sessionStorage.removeItem(DID_SCROLL_KEY);
    } catch (_) {}
  }, true);

  function shouldScrollNow() {
    if (sessionStorage.getItem(DID_SCROLL_KEY) === '1') return false;
    if (sessionStorage.getItem(ORIGIN_KEY)     !== '1') return false;
    var ts = Number(sessionStorage.getItem(ORIGIN_TS_KEY) || '0');
    if (!ts || Date.now() - ts > ORIGIN_TTL_MS) return false;
    return true;
  }

  function markDidScroll() {
    sessionStorage.setItem(DID_SCROLL_KEY, '1');
    sessionStorage.removeItem(ORIGIN_KEY);
    sessionStorage.removeItem(ORIGIN_TS_KEY);
  }

  function waitForElement(root, selector, timeoutMs) {
    return new Promise(function (resolve) {
      var el = root.querySelector ? root.querySelector(selector) : null;
      if (el) return resolve(el);
      var done = false;
      var obs = new MutationObserver(function () {
        if (done) return;
        var found = root.querySelector ? root.querySelector(selector) : null;
        if (found) { done = true; obs.disconnect(); resolve(found); }
      });
      obs.observe(
        root === document ? document.documentElement : root,
        { childList: true, subtree: true }
      );
      window.setTimeout(function () {
        if (done) return;
        done = true; obs.disconnect(); resolve(null);
      }, timeoutMs);
    });
  }

  function scrollToElement(el) {
    var rect = el.getBoundingClientRect();
    var top  = window.scrollY + rect.top - 120;
    try { window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' }); }
    catch (_) { window.scrollTo(0, Math.max(0, top)); }
  }

  document.addEventListener('cf:ready', function () {
    if (!shouldScrollNow()) {
      log('cf:ready -> no scroll');
      return;
    }
    var form =
      document.querySelector('form[data-cf-form="kntPQW"]') ||
      document.querySelector('form[data-cf-form]');
    if (!form) { log('cf:ready -> no form'); return; }

    log('cf:ready -> waiting for .cf-add-entry');
    waitForElement(form, '.cf-add-entry', 15000).then(function (btn) {
      if (!btn) return;
      if (sessionStorage.getItem(DID_SCROLL_KEY) === '1') return;
      markDidScroll();
      window.setTimeout(function () {
        window.requestAnimationFrame(function () {
          try { scrollToElement(btn); }
          catch (_) { btn.scrollIntoView(true); }
        });
      }, 200);
    });
  });
})();


// =============================================================================
// Live entry heading: "Pet N of M → Pet N of M - {name}"
// =============================================================================
(function () {
  var NAME_KEY = 'name';

  function stripNameSuffix(text) {
    return String(text || '').replace(/\s*-\s*.*$/, '').trim();
  }

  function getStrong(entryEl) {
    return entryEl ? entryEl.querySelector('.cf-entry-heading strong') : null;
  }

  function getNameInput(entryEl) {
    return entryEl
      ? entryEl.querySelector('[data-cf-column-key="' + NAME_KEY + '"]')
      : null;
  }

  function isConnected(el) {
    if (!el) return false;
    if (typeof el.isConnected === 'boolean') return el.isConnected;
    return document.documentElement.contains(el);
  }

  function updateHeading(entryEl, nameValue) {
    if (!entryEl || !isConnected(entryEl)) return;
    var strong = getStrong(entryEl);
    if (!strong) return;
    if (!strong.dataset.petzparkBaseHeading) {
      strong.dataset.petzparkBaseHeading = stripNameSuffix(strong.textContent);
    }
    var base = strong.dataset.petzparkBaseHeading;
    var name;
    if (typeof nameValue === 'string') {
      name = nameValue.trim();
    } else {
      var input = getNameInput(entryEl);
      name = input ? (input.value || '').trim() : '';
    }
    strong.textContent = name ? base + ' - ' + name : base;
  }

  function rebuildAllHeadings(formEl) {
    formEl.querySelectorAll('.cf-group-entry').forEach(function (entryEl) {
      if (!isConnected(entryEl)) return;
      var strong = getStrong(entryEl);
      if (!strong) return;
      strong.dataset.petzparkBaseHeading = stripNameSuffix(strong.textContent);
      updateHeading(entryEl);
    });
  }

  function bindFormListeners(formEl) {
    if (formEl.dataset.petzparkNameListenerBound === '1') return;
    formEl.dataset.petzparkNameListenerBound = '1';
    formEl.addEventListener('cf:field_changed', function (event) {
      try {
        var detail    = event && event.detail ? event.detail : null;
        var columnKey = detail ? detail.columnKey : null;
        if (columnKey !== NAME_KEY) return;
        if (!isConnected(event.target)) return;
        var entryEl = event.target && event.target.closest
          ? event.target.closest('.cf-group-entry')
          : null;
        if (!entryEl || !isConnected(entryEl)) return;
        var value = (detail && typeof detail.value !== 'undefined')
          ? String(detail.value)
          : undefined;
        updateHeading(entryEl, value);
      } catch (_) {}
    });
  }

  function setupMutationObserver(formEl) {
    if (formEl.dataset.petzparkMutationObserverSetup === '1') return;
    formEl.dataset.petzparkMutationObserverSetup = '1';
    var obs = new MutationObserver(function (mutations) {
      var structureChanged = false;
      outer:
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        var lists = [m.addedNodes, m.removedNodes];
        for (var li = 0; li < lists.length; li++) {
          var list = lists[li];
          for (var j = 0; j < list.length; j++) {
            var node = list[j];
            if (!(node instanceof Element)) continue;
            if (
              node.classList.contains('cf-group-entry') ||
              (node.querySelector && node.querySelector('.cf-group-entry'))
            ) {
              structureChanged = true;
              break outer;
            }
          }
        }
      }
      if (!structureChanged) return;
      window.requestAnimationFrame(function () {
        rebuildAllHeadings(formEl);
      });
    });
    obs.observe(formEl, { childList: true, subtree: true });
  }

  document.addEventListener('cf:ready', function () {
    var forms = document.querySelectorAll('form[data-cf-form]');
    if (!forms || !forms.length) return;
    forms.forEach(function (formEl) {
      bindFormListeners(formEl);
      rebuildAllHeadings(formEl);
      setupMutationObserver(formEl);
    });
  });
})();


// =============================================================================
// Accordion — step headings per entry
// =============================================================================
(function () {
  var HEADER_CLASS     = 'petzpark-accordion-step-header';
  var ARROW_CLASS      = 'petzpark-accordion-arrow';
  var RANGE_CLASS      = 'petzpark-accordion-range';
  var INIT_DEBOUNCE_MS = 150;

  var ARROW_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" ' +
    'width="18" height="18" fill="#f79903" stroke="#f79903" stroke-width="0.8" ' +
    'stroke-linejoin="round" aria-hidden="true" focusable="false">' +
    '<path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293' +
    'l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0' +
    ' 0 1 0-.708z"/></svg>';

  var _pendingInits   = {};
  var _entryIdCounter = 0;

  function getEntryId(entryEl) {
    if (!entryEl.dataset.petzparkEntryId) {
      entryEl.dataset.petzparkEntryId = String(++_entryIdCounter);
    }
    return entryEl.dataset.petzparkEntryId;
  }

  function scheduleInitEntry(entryEl, delayMs) {
    var id = getEntryId(entryEl);
    if (_pendingInits[id]) window.clearTimeout(_pendingInits[id]);
    var ms = (typeof delayMs === 'number') ? delayMs : INIT_DEBOUNCE_MS;
    _pendingInits[id] = window.setTimeout(function () {
      delete _pendingInits[id];
      var live = document.querySelector('[data-petzpark-entry-id="' + id + '"]');
      if (live) initEntryAccordion(live);
    }, ms);
  }

  function isStepHeadingContainer(el) {
    if (!el) return false;
    var h2 = el.querySelector('h2');
    if (!h2) return false;
    return /^Step\s+\d+/i.test((h2.textContent || '').trim());
  }

  function getStepHeaders(fieldsetEl) {
    return Array.prototype.filter.call(
      fieldsetEl.querySelectorAll('.cf-field-container.cf-field--heading'),
      isStepHeadingContainer
    );
  }

  function ensureArrow(headerEl) {
    var existing = headerEl.querySelector('.' + ARROW_CLASS);
    if (existing) {
      if (!existing.querySelector('svg')) existing.innerHTML = ARROW_SVG;
      return;
    }
    var arrow = document.createElement('span');
    arrow.className = ARROW_CLASS;
    arrow.setAttribute('aria-hidden', 'true');
    arrow.innerHTML = ARROW_SVG;
    headerEl.appendChild(arrow);
  }

  function applyBorderClasses(steps) {
    steps.forEach(function (step, idx) {
      step.header.classList.toggle('petzpark-accordion-step-first', idx === 0);
      step.header.classList.toggle('petzpark-accordion-step-last',  idx === steps.length - 1);
    });
  }

  function computeSteps(entryEl) {
    var fieldRoot  = entryEl.querySelector('.cf-entry-fields');
    if (!fieldRoot) return null;
    var fieldsetEl = fieldRoot.querySelector('fieldset.cf-fields-container') || fieldRoot;
    var headers    = getStepHeaders(fieldsetEl);
    if (!headers.length) return null;
    return headers.map(function (header, i) {
      var nextHeader = headers[i + 1] || null;
      var rangeNodes = [];
      var node = header.nextElementSibling;
      while (node && node !== nextHeader) {
        if (node instanceof Element) rangeNodes.push(node);
        node = node.nextElementSibling;
      }
      return { header: header, rangeNodes: rangeNodes };
    });
  }

  function setNodeOpen(node, open) {
    if (!node || !(node instanceof Element)) return;
    node.classList.add(RANGE_CLASS);
    node.style.overflow      = 'hidden';
    node.style.pointerEvents = open ? 'auto' : 'none';
    node.style.opacity       = open ? '1'    : '0';
    var previousDoneHandler = node._petzparkHeightDoneHandler;
    if (previousDoneHandler) {
      node.removeEventListener('transitionend', previousDoneHandler);
      node._petzparkHeightDoneHandler = null;
    }
    if (node._petzparkHeightDoneTimeout) {
      window.clearTimeout(node._petzparkHeightDoneTimeout);
      node._petzparkHeightDoneTimeout = null;
    }

    if (open) {
      var startHeight = node.getBoundingClientRect().height;
      var targetHeight = node.scrollHeight;
      if (targetHeight <= 0) {
        node.style.height = 'auto';
        return;
      }
      node.style.height = startHeight + 'px';
      window.requestAnimationFrame(function () {
        node.style.height = targetHeight + 'px';
      });

      var doneOpen = function (event) {
        if (event && event.propertyName && event.propertyName !== 'height') return;
        node.style.height = 'auto';
        node.removeEventListener('transitionend', doneOpen);
        node._petzparkHeightDoneHandler = null;
        if (node._petzparkHeightDoneTimeout) {
          window.clearTimeout(node._petzparkHeightDoneTimeout);
          node._petzparkHeightDoneTimeout = null;
        }
      };
      node._petzparkHeightDoneHandler = doneOpen;
      node.addEventListener('transitionend', doneOpen);
      // Fallback: transitionend may not fire when target height doesn't change
      // (common with conditionally-hidden fields). Ensure open nodes become auto.
      node._petzparkHeightDoneTimeout = window.setTimeout(function () {
        doneOpen({ propertyName: 'height' });
      }, 450);
      return;
    }

    var currentHeight = node.getBoundingClientRect().height;
    if (currentHeight <= 0) {
      node.style.height = '0px';
      return;
    }
    node.style.height = currentHeight + 'px';
    window.requestAnimationFrame(function () {
      node.style.height = '0px';
    });
  }

  function applyOpenSteps(steps, openIndexes) {
    var openSet = {};
    (openIndexes || []).forEach(function (i) { openSet[i] = true; });
    steps.forEach(function (step, idx) {
      var open = !!openSet[idx];
      step.header.dataset.petzparkOpen = open ? 'true' : 'false';
      step.rangeNodes.forEach(function (node) { setNodeOpen(node, open); });
    });
  }

  function scrollToHeader(headerEl) {
    // Wait for the CSS height transition to finish (350ms per CSS) before
    // measuring, so any collapsing step above has fully shrunk. Measuring
    // during the transition gives an incorrect top value that overshoots.
    window.setTimeout(function () {
      try {
        var rect = headerEl.getBoundingClientRect();
        var top  = window.scrollY + rect.top - 16;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      } catch (_) {
        headerEl.scrollIntoView(true);
      }
    }, 360);
  }

  function invalidStepIndexes(steps) {
    var result = [];
    steps.forEach(function (step, idx) {
      var hasInvalid = step.rangeNodes.some(function (node) {
        return node && node.querySelector &&
               node.querySelector('[data-cf-invalid="true"]');
      });
      if (hasInvalid) result.push(idx);
    });
    return result;
  }

  function openInvalidStepsInForm(formEl) {
    formEl.querySelectorAll('.cf-group-entry').forEach(function (entryEl) {
      var steps = entryEl.__petzparkAccordionSteps;
      if (!steps) return;
      var idxs = invalidStepIndexes(steps);
      if (idxs.length) applyOpenSteps(steps, idxs);
    });
  }

  function initEntryAccordion(entryEl) {
    var steps = computeSteps(entryEl);
    if (!steps || !steps.length) return;

    entryEl.__petzparkAccordionSteps = steps;
    applyBorderClasses(steps);

    steps.forEach(function (step, idx) {
      step.header.classList.add(HEADER_CLASS);
      step.header.setAttribute('role', 'button');
      if (!step.header.hasAttribute('tabindex')) {
        step.header.setAttribute('tabindex', '0');
      }
      ensureArrow(step.header);

      if (step.header._petzparkClickHandler) {
        step.header.removeEventListener('click',   step.header._petzparkClickHandler);
        step.header.removeEventListener('keydown', step.header._petzparkKeyHandler);
      }

      var clickHandler = (function (capturedIdx, capturedEntry, capturedHeader) {
        return function (ev) {
          // Guard: ignore taps that originate from interactive children.
          // On mobile, native <select> picker dismissal fires a click whose
          // target can be the wrapper div rather than the <select> itself —
          // so we check all known CF interactive containers, not just elements.
          if (ev && ev.target && ev.target.closest) {
            var t = ev.target;
            if (
              t.closest('input, select, textarea, button, a') ||
              t.closest('.cf-select-wrap')                    ||
              t.closest('.cf-file-preview-container')         ||
              t.closest('.cf-enum-field__choices')            ||
              t.closest('.cf-down-arrow')
            ) return;
          }

          var currentSteps = capturedEntry.__petzparkAccordionSteps;
          if (!currentSteps) return;

          var isOpen = currentSteps[capturedIdx].header.dataset.petzparkOpen === 'true';

          if (isOpen) {
            var remaining = currentSteps.reduce(function (acc, s, i) {
              if (i !== capturedIdx && s.header.dataset.petzparkOpen === 'true') acc.push(i);
              return acc;
            }, []);
            applyOpenSteps(currentSteps, remaining);
          } else {
            applyOpenSteps(currentSteps, [capturedIdx]);
            scrollToHeader(capturedHeader);
          }
        };
      })(idx, entryEl, step.header);

      var keyHandler = function (ev) {
        var key = ev.key || '';
        if (key === 'Enter' || key === ' ') {
          ev.preventDefault();
          clickHandler(ev);
        }
      };

      step.header._petzparkClickHandler = clickHandler;
      step.header._petzparkKeyHandler   = keyHandler;
      step.header.addEventListener('click',   clickHandler);
      step.header.addEventListener('keydown', keyHandler);
    });

    applyOpenSteps(steps, [0]);
  }

  function initFormAccordion(formEl) {
    if (formEl.dataset.petzparkAccordionBound === '1') return;
    formEl.dataset.petzparkAccordionBound = '1';

    // Pre-hide all range nodes instantly to prevent flash of previous open state.
    if (!formEl.dataset.petzparkInitHidden) {
      formEl.dataset.petzparkInitHidden = '1';
      formEl.querySelectorAll('.cf-group-entry').forEach(function (entryEl) {
        var fieldRoot  = entryEl.querySelector('.cf-entry-fields');
        if (!fieldRoot) return;
        var fieldsetEl = fieldRoot.querySelector('fieldset.cf-fields-container') || fieldRoot;
        fieldsetEl.querySelectorAll('.cf-field-container').forEach(function (node) {
          if (isStepHeadingContainer(node)) return;
          node.style.transition    = 'none';
          node.style.overflow      = 'hidden';
          node.style.height        = '0px';
          node.style.opacity       = '0';
          node.style.pointerEvents = 'none';
          window.requestAnimationFrame(function () { node.style.transition = ''; });
        });
      });
    }

    // Schedule init for all existing entries so CF hydration finishes first.
    formEl.querySelectorAll('.cf-group-entry').forEach(function (entryEl) {
      scheduleInitEntry(entryEl, INIT_DEBOUNCE_MS);
    });

    // Client-side validation
    var submitBtn = formEl.querySelector('.cf-submit-form');
    if (submitBtn && !submitBtn._petzparkSubmitBound) {
      submitBtn._petzparkSubmitBound = true;
      submitBtn.addEventListener('click', function () {
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            window.setTimeout(function () { openInvalidStepsInForm(formEl); }, 100);
          });
        });
      }, true);
    }

    // Server-side errors
    formEl.addEventListener('cf:form_submission_failed', function () {
      window.setTimeout(function () { openInvalidStepsInForm(formEl); }, 75);
    });

    // Open step when a field inside it becomes invalid while collapsed.
    // Guard: only act when the step containing the invalid field is OPEN —
    // this prevents CF's rule-engine auto-validation (e.g. when selecting
    // pet type shows/hides health fields and validates them) from forcing
    // closed steps open. Users should only see auto-open on fields they
    // have actively interacted with inside a currently visible step.
    formEl.addEventListener('cf:field_validated', function (event) {
      try {
        var fieldEl = event && event.target ? event.target : null;
        if (!fieldEl || !fieldEl.closest) return;
        var invalidAncestor = fieldEl.closest('[data-cf-invalid="true"]');
        if (!invalidAncestor) return;
        var entryEl = fieldEl.closest('.cf-group-entry');
        if (!entryEl) return;
        var steps = entryEl.__petzparkAccordionSteps;
        if (!steps) return;
        var idxToOpen = -1;
        for (var i = 0; i < steps.length; i++) {
          var inStep = steps[i].rangeNodes.some(function (node) {
            return node && node.contains && node.contains(invalidAncestor);
          });
          if (inStep) { idxToOpen = i; break; }
        }
        // Only open if the step is currently closed AND it was the active
        // (open) step when the user triggered the validation — i.e. don't
        // let CF's rule-engine auto-validations open steps the user hasn't
        // navigated to yet. We detect "user interaction" by checking whether
        // the invalid field has been touched (data-cf-invalid is set only
        // after the user defocuses a field per CF docs) AND its step was open.
        if (idxToOpen >= 0 && steps[idxToOpen].header.dataset.petzparkOpen !== 'true') {
          // The step is closed. Only open it if the field has been user-touched,
          // which we infer from the field container NOT being the one that CF
          // just made visible via a rule action. We check: if the field's parent
          // step-range-node currently has pointer-events:none (closed), the
          // field was never visible to the user, so skip auto-open.
          var parentRangeNode = null;
          for (var ri = 0; ri < steps[idxToOpen].rangeNodes.length; ri++) {
            if (steps[idxToOpen].rangeNodes[ri].contains(invalidAncestor)) {
              parentRangeNode = steps[idxToOpen].rangeNodes[ri];
              break;
            }
          }
          // If the containing range node has pointerEvents:none it was never
          // shown to the user — skip. Otherwise open the step.
          if (parentRangeNode && parentRangeNode.style.pointerEvents === 'none') return;
          applyOpenSteps(steps, [idxToOpen]);
        }
      } catch (_) {}
    });

    // Watch for new entries added dynamically (Add Pet button)
    if (formEl.dataset.petzparkAccordionObserver === '1') return;
    formEl.dataset.petzparkAccordionObserver = '1';

    var obs = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (!m.addedNodes || !m.addedNodes.length) continue;
        for (var j = 0; j < m.addedNodes.length; j++) {
          var node = m.addedNodes[j];
          if (!(node instanceof Element)) continue;

          // Only treat as a new entry when the added node IS a .cf-group-entry
          // OR its direct parent is the CF entry list container.
          // Never use querySelector here — that would match CF rule-engine
          // show/hide mutations (e.g. dog breed appearing after selecting Dog)
          // which add nodes INSIDE an existing entry, falsely triggering a
          // reinit that resets the open step back to Step 1.
          if (node.classList && node.classList.contains('cf-group-entry')) {
            scheduleInitEntry(node);
          } else if (
            node.parentNode &&
            node.parentNode.classList &&
            node.parentNode.classList.contains('cf-entry-list')
          ) {
            var directEntry = node.querySelector && node.querySelector(':scope > .cf-group-entry');
            if (!directEntry) {
              // parentNode is cf-entry-list but no direct child is an entry —
              // this is a wrapper CF inserts; find the first entry inside it.
              directEntry = node.querySelector && node.querySelector('.cf-group-entry');
            }
            if (directEntry) scheduleInitEntry(directEntry);
          }
        }
      }
    });

    obs.observe(formEl, { childList: true, subtree: true });
  }

  document.addEventListener('cf:ready', function () {
    var forms = document.querySelectorAll('form[data-cf-form]');
    if (!forms || !forms.length) return;
    forms.forEach(function (formEl) {
      if (!formEl.querySelector('.pet-profiles--form')) return;
      initFormAccordion(formEl);
    });
  });
})();


// =============================================================================
// Weight field — one decimal place maximum
// =============================================================================
(function () {
  function isWeightInput(target) {
    if (!target) return false;
    return !!(target.closest && target.closest('.profile-field--weight'));
  }

  function wouldExceedOneDecimal(input, insertedText) {
    var start   = input.selectionStart;
    var end     = input.selectionEnd;
    var current = input.value || '';
    var next    = current.slice(0, start) + insertedText + current.slice(end);
    if (!next.includes('.')) return false;
    var parts = next.split('.');
    if (parts.length > 2) return true;
    return parts[1].length > 1;
  }

  document.addEventListener('beforeinput', function (e) {
    if (!isWeightInput(e.target)) return;
    if (e.inputType !== 'insertText' &&
        e.inputType !== 'insertFromPaste' &&
        e.inputType !== 'insertFromDrop') return;
    var data = e.data || '';
    if (!data) return;
    if (wouldExceedOneDecimal(e.target, data)) e.preventDefault();
  }, true);

  document.addEventListener('input', function (e) {
    if (!isWeightInput(e.target)) return;
    var input = e.target;
    var value = input.value;
    if (!value.includes('.')) return;
    var parts = value.split('.');
    if (parts[1].length <= 1) return;
    var caretPos  = input.selectionStart;
    var corrected = parts[0] + '.' + parts[1].charAt(0);
    input.value   = corrected;
    var newCaret  = Math.min(caretPos, corrected.length);
    try { input.setSelectionRange(newCaret, newCaret); } catch (_) {}
  }, true);
})();